import { Component, OnInit } from '@angular/core';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service';

@Component({
  selector: 'app-quienes-somos',
  templateUrl: './quienes-somos.component.html',
  styleUrls: ['./quienes-somos.component.css']
})
export class QuienesSomosComponent implements OnInit {

  titulo: string
  descripcion: string
  datosObjetivos: { imagen: string; descripcion: string; }[];
  datosAvocados: { imagen: string; descripcion: string; }[];
  subtituloA: string
  subtituloB: string

  constructor(private distribuidor: DistribuidorDeContenidosService) {
    this.titulo = distribuidor.contenidoQuienesSomos.titulo;
    this.descripcion = distribuidor.contenidoQuienesSomos.descripcion;
    this.datosObjetivos = distribuidor.contenidoQuienesSomos.datosObjetivos;
    this.datosAvocados = distribuidor.contenidoQuienesSomos.datosAvocados;
    this.subtituloA = distribuidor.contenidoQuienesSomos.subtituloA;
    this.subtituloB = distribuidor.contenidoQuienesSomos.subtituloB;
  }

  ngOnInit(): void {
  }

}
